import * as React from "react";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import { routes } from "../../../appRoutingHelpers";
import { OrganizationKeyName } from "../../../model/Organization";
import { UserProfileDataResponse } from "../../../service/api-response";
import { RootState } from "../../../store";
import * as organizationSelectors from "../../organization/organizationSelectors";
import { withTranslation } from "react-i18next";
import { StyledText } from "../../../assets/typography/typography";
import { colors } from "../../../components/colors";
import { ExternalLinkButton } from "../../../components/ExternalLinkButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { UserAvatar } from "./UserAvatar";
import { LinkButton } from "../../../components/Buttons";

interface OwnProps {
  userProfile: UserProfileDataResponse;
  organization: OrganizationKeyName;
  mixpanelLink: string;
}

interface Props extends OwnProps {
  isStripeLinkVisible: boolean;
  isMixpanelLinkVisible: boolean;
  mixpanelLink: string;
}

interface State {}

const mapStateToProps = (state: RootState, ownProps: OwnProps) => {
  return {
    isStripeLinkVisible: organizationSelectors.isUserProfileStripeLinkVisible(
      state
    ),
    isMixpanelLinkVisible: organizationSelectors.isUserProfileMixpanelLinkVisible(
      state
    ),
    mixpanelLink: organizationSelectors.mixpanelLink(state),
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {};
};

class UserProfileAvatarPartial extends React.Component<Props, State> {
  render() {
    const userProfile = this.props.userProfile;
    const organization = this.props.organization;

    let avatarStyle: React.CSSProperties = {};

    if (userProfile.profileImages && userProfile.profileImages.length > 0) {
      avatarStyle.backgroundImage = `url(${userProfile.profileImages[0].url})`;
    }

    return (
      <>
        <div className="card">
          <div
            className="card-header border-bottom-0 mt-4"
            style={{ gap: "16px" }}
          >
            <UserAvatar name={userProfile.name} />
            <div className="d-flex flex-column" style={{ gap: "8px" }}>
              <StyledText
                color={colors.textPrimary}
                className="bodyHeaderOneSemi mb-0"
              >
                {userProfile.name}
              </StyledText>
              <StyledText
                color={colors.textSecondary}
                className="bodyTextRegular mb-0"
              >
                {userProfile.id}
              </StyledText>
            </div>
          </div>
          <div className="card-body d-flex flex-column" style={{ gap: "16px" }}>
            <div className="d-flex flex-row" style={{ gap: "16px" }}>
              {this.props.isStripeLinkVisible && userProfile.stripeId && (
                <ExternalLinkButton
                  backgroundColor={colors.transparent}
                  hoverColor={colors.ctaLight}
                  textColor={colors.textPrimary}
                  text="Stripe"
                  href={`https://dashboard.stripe.com/customers/${userProfile.stripeId}`}
                  width="fit-content"
                  icon={
                    <FontAwesomeIcon
                      icon={solid("link")}
                      color={colors.textPrimary}
                    />
                  }
                />
              )}
              {this.props.isMixpanelLinkVisible && userProfile.mixpanelId && (
                <ExternalLinkButton
                  backgroundColor={colors.transparent}
                  hoverColor={colors.ctaLight}
                  textColor={colors.textPrimary}
                  text="Mixpanel"
                  width="fit-content"
                  href={`${this.props.mixpanelLink}/app/profile#distinct_id=${userProfile.mixpanelId}`}
                  icon={
                    <FontAwesomeIcon
                      icon={solid("link")}
                      color={colors.textPrimary}
                    />
                  }
                />
              )}
              <LinkButton
                backgroundColor={colors.transparent}
                hoverColor={colors.ctaLight}
                color={colors.textPrimary}
                to={routes.userEventLogList(organization, userProfile.id)}
              >
                Logs
              </LinkButton>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(UserProfileAvatarPartial));
